import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { useGlobal } from '@rcg/ui-react';
import TravelPlansRoyal from '../TravelPlansRoyal';
import TravelPlansCel from '../TravelPlansCel';
import Dictionary from '../../utils/dictionary';
import useDictionary from '../../hooks/useDictionary';
import { BRAND } from '../../utils/constants';
import { getCookies, appendGlobalizationToPath } from '../../utils/common';
import getBrand from '../../utils/getBrand';
import useStyles from './useStyles';

const TravelPlansUnified = ({ supportPhoneNumber, ldFlags }) => {
  const classes = useStyles();
  const isCelebrity = getBrand()?.id === BRAND.CELEBRITY;
  const getDictionary = useDictionary(Dictionary);
  const { data } = useGlobal();
  const accessToken = getCookies('accessToken');
  const isAuthenticated = accessToken !== undefined && accessToken !== null && accessToken !== '';
  const faqPathUrl = getDictionary(Dictionary.airConfirmationFaqViewAllAnchor.key);
  const faqHrefUrl = appendGlobalizationToPath(faqPathUrl, data);

  return (
    <>
      <Typography variant="subtitle1">
        {getDictionary(Dictionary.airTravelPlansTitle.key)}
      </Typography>
      {isCelebrity ? (
        <TravelPlansCel isAuthenticated={isAuthenticated} ldFlags={ldFlags} />
      ) : (
        <TravelPlansRoyal
          supportPhoneNumber={supportPhoneNumber}
          isAuthenticated={isAuthenticated}
          ldFlags={ldFlags}
        />
      )}
      <Typography variant="subtitle1">
        {getDictionary(Dictionary.airFaqsMessageDescription.key)}
        <a className={classes.faqLink} href={faqHrefUrl}>
          {getDictionary(Dictionary.airFaq.key)}
        </a>
      </Typography>
    </>
  );
};

TravelPlansUnified.propTypes = {
  supportPhoneNumber: PropTypes.string,
};

export default TravelPlansUnified;
